import React from 'react';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';

import { AppConfigI } from 'appConfigs/example';
import getAppConfigs from 'modules/appConfig/reducer';
import ReduxConnector from './ReduxConnector';
import OidcSilentProvider from './silentProvider';

const appConfigs = getAppConfigs() as AppConfigI;

// storybook public url is '.'
const publicURL = process.env.PUBLIC_URL === '.' ? '/' : process.env.PUBLIC_URL;

const redirectUrl = new URL(
	'oidc/callback',
	`${globalThis.location?.origin}${publicURL}`,
);

const oidcSettings: AuthProviderProps = {
	authority: appConfigs?.openId.authority,
	client_id: appConfigs?.openId.client_id,
	accessTokenExpiringNotificationTimeInSeconds:
		appConfigs?.openId.accessTokenExpiringNotificationTime,
	redirect_uri: redirectUrl.href,
	response_type: 'code',
	scope: 'openid profile grants',
	client_secret: '',
	popupWindowFeatures: {
		width: 520,
		height: 800,
	},
};

/**
 * Oidc Provider
 */
export function OidcProvider(props: { children: React.ReactNode }) {
	const { children } = props;
	return (
		<AuthProvider {...oidcSettings}>
			<OidcSilentProvider>
				<ReduxConnector />
				{children}
			</OidcSilentProvider>
		</AuthProvider>
	);
}

export default OidcProvider;
